import { CheckItem, FileCheckRuleItem, MissingType } from 'common/types/export-version-file';

/* eslint-disable max-lines */
export enum RuleType {
  // 质检主体
  DCCFile = 'DCCFile',
  DiffuseTexture = 'DiffuseTexture',
  BaseColorTexture = 'BaseColorTexture',
  MRATexture = 'MRATexture',
  MetallicTexture = 'MetallicTexture',
  RoughnessTexture = 'RoughnessTexture',
  AOTexture = 'AOTexture',
  SGTexture = 'SGTexture',
  NormalTexture = 'NormalTexture',
  EmissiveTexture = 'EmissiveTexture',
  sppFile = 'sppFile',
  psdFile = 'psdFile',
  arpFile = 'arpFile',
  rsFile = 'rsFile',
  fbxFile = 'fbxFile',
  Picture = 'Picture',
  Metadata = 'Metadata',
  Video = 'Video',
  Animation = 'Animation',
}

export const RuleTypeFileTypeMap = {
  [RuleType.DCCFile]: ['max', 'ma', 'mb', 'ztl'],
  [RuleType.DiffuseTexture]: ['tga', 'png', 'jpg'],
  [RuleType.BaseColorTexture]: ['tga', 'png', 'jpg'],
  [RuleType.MRATexture]: ['tga', 'png', 'jpg'],
  [RuleType.AOTexture]: ['tga', 'png', 'jpg'],
  [RuleType.MetallicTexture]: ['tga', 'png', 'jpg'],
  [RuleType.RoughnessTexture]: ['tga', 'png', 'jpg'],
  [RuleType.SGTexture]: ['tga', 'png', 'jpg'],
  [RuleType.NormalTexture]: ['tga', 'png', 'jpg'],
  [RuleType.EmissiveTexture]: ['tga', 'png', 'jpg'],
  [RuleType.sppFile]: ['spp'],
  [RuleType.psdFile]: ['psd', 'psb'],
  [RuleType.arpFile]: ['arp'],
  [RuleType.rsFile]: ['rs'],
  [RuleType.fbxFile]: ['fbx'],
  [RuleType.Picture]: ['tga', 'png', 'jpg', 'gif', 'psd', 'psb', 'jpeg', 'bmp', 'webp'],
  [RuleType.Metadata]: ['json', 'yaotai', 'nielian', 'rs', 'ppt', 'pptx', 'doc', 'docx', 'xlsx', 'csv', 'txt'],
  [RuleType.Video]: ['mov', 'mp4', 'avi'],
  [RuleType.Animation]: ['max', 'ma', 'mb', 'fbx'],
};

// 提交规范header规则：p.s:文件列表展示文件名称
export const VersionFileTypeMap = {
  [RuleType.DCCFile]: 'DCCFile',
  [RuleType.DiffuseTexture]: 'Diffuse（漫反射）贴图',
  [RuleType.BaseColorTexture]: 'BaseColor（颜色）贴图',
  [RuleType.MRATexture]: 'MRA（金属度&粗糙度&遮蔽）贴图',
  [RuleType.SGTexture]: 'SG（高光&光泽度）贴图',
  [RuleType.NormalTexture]: 'Normal（法线）贴图',
  [RuleType.AOTexture]: 'AOT（遮蔽）贴图',
  [RuleType.EmissiveTexture]: 'Emissive（自发光）贴图',
  SubstancePainter: 'SubstancePainter',
};

// 文件规则
export enum CheckType {
  // 质检主体：文件
  // 常规必备参数(json一级数据)
  FileName = 'fileName',
  FileType = 'fileType',
  IsRequired = 'missing',
  FileNameDesc = 'fileNameDesc',

  // 可选参数(json rules子项)
  // 取值json 中的ruleType
  FileSize = 'FileSize',
  Version = 'Version',
  Unit = 'Unit',
  TexDependency = 'TexDependency',
  UVSet = 'UVSet',
  Resolution = 'Resolution',
  Channel = 'Channel',

  // 视频文件
  FrameRate = 'FrameRate',
  TotalFrames = 'TotalFrames',
  ColorSpace = 'ColorSpace',
  BitRate = 'BitRate',

  HasAnimation = 'HasAnimation',
  HasSkeleton = 'HasSkeleton',
  HasBinding = 'HasBinding',

  // 质检主体：非文件
  // 组规则
  Name = 'name',
  GroupCheck = 'Group',
  // 材质球规则
  MaterialCheck = 'Material',

  // 2024.5.18新增
  ImagePlagiarism = 'ImagePlagiarism', //图片查重
  ImageRisk = 'ImageRisk', //图片风险
  // 2025.6.18新增
  AssetName = 'AssetName', // 资产名称
  AssetId = 'AssetId', // 资产ID
  AssetType = 'AssetType', // 资产类型
  AssetStyle = 'AssetStyle', // 资产风格
  UpdateTime = 'UpdateTime', // 更新时间
  Summary = 'Summary', // 资产简介
  OccupyNum = 'OccupyNum', // 占用值
  ItemNum = 'ItemNum', // 物品数量
  CollectNum = 'CollectNum', // 收藏数量
  LikeNum = 'LikeNum', // 点赞数量
  PlayNum = 'PlayNum', // 游玩数量
  PlayTimes = 'PlayTimes', // 游玩次数
  AuthorPass = 'AuthorPass', // 是否通过
  PassRate = 'PassRate', // 通过率
  ScoreNum = 'ScoreNum', // 评分数量
  Score = 'Score', // 评分
  Label = 'Label', //标签
}

export const CHECK_VALUE_OPTIONS = {
  [CheckType.ColorSpace]: ['BT709', 'BT2020'],
  [CheckType.Resolution]: [
    { value: { x: 512, y: 512 }, label: '512' },
    { value: { x: 1024, y: 1024 }, label: '1024' },
    { value: { x: 2048, y: 2048 }, label: '2048' },
    { value: { x: 4096, y: 4096 }, label: '4096' },
  ],
};

// group规则
export enum GroupRulesEnum {
  FaceCount = 'FaceCount',
  TriCount = 'TriCount',
  Normalized = 'Normalized',
  Center = 'Center',
  MeshCount = 'MeshCount',
  MeshName = 'MeshName',
}
// 材质球规则
export enum MaterialRulesEnum {
  MaterialName = 'MaterialName',
}

export const DEFAULT_FORM_VALUE = { [`${CheckType.IsRequired}`]: MissingType.Error };

export const getCheckTypeJsonMap = (checkType) => {
  return Object.assign({}, CheckTypeJsonMap[`${checkType}`]);
};

export const CheckTypeJsonMap: { [key: string]: FileCheckRuleItem } = {
  [CheckType.ColorSpace]: {
    ruleType: CheckType.ColorSpace,
    ruleLabel: '颜色空间',
    checkValue: null,
    checkMethod: 'Equal',
    submitMessage: '颜色空间为${checkValue}',
    checkMessage: '请核对颜色空间为${checkValue}',
  },
  [CheckType.TotalFrames]: {
    ruleType: CheckType.TotalFrames,
    ruleLabel: '总帧数',
    checkValue: null,
    checkMethod: 'Less',
    submitMessage: '总帧数少于${checkValue}',
    checkMessage: '请核对总帧数少于${checkValue}',
  },
  [CheckType.BitRate]: {
    ruleType: CheckType.BitRate,
    ruleLabel: '比特率',
    checkValue: null,
    checkMethod: 'Less',
    submitMessage: '比特率少于${checkValue}Mbps',
    checkMessage: '请核对比特率少于${checkValue}Mbps',
  },
  [CheckType.HasAnimation]: {
    ruleType: CheckType.HasAnimation,
    ruleLabel: '有无动画',
    checkValue: true,
    checkMethod: 'Equal',
    submitMessage: '需要含动画',
    checkMessage: '需要含动画',
  },
  [CheckType.HasSkeleton]: {
    ruleType: CheckType.HasSkeleton,
    ruleLabel: '有无骨骼',
    checkValue: true,
    checkMethod: 'Equal',
    submitMessage: '需要含骨骼',
    checkMessage: '需要含骨骼',
  },
  [CheckType.HasBinding]: {
    ruleType: CheckType.HasBinding,
    ruleLabel: '有无绑定',
    checkValue: true,
    checkMethod: 'Equal',
    submitMessage: '需要绑定',
    checkMessage: '需要绑定',
  },
  [CheckType.FrameRate]: {
    ruleType: CheckType.FrameRate,
    ruleLabel: '帧率',
    checkValue: null,
    checkMethod: 'Less',
    submitMessage: '帧率小于${checkValue}fps',
    checkMessage: '帧率小于${checkValue}fps',
  },
  [CheckType.FileSize]: {
    ruleType: CheckType.FileSize,
    ruleLabel: '文件大小',
    checkValue: null,
    checkMethod: 'Less',
    submitMessage: '文件大小小于${checkValue}',
    checkMessage: '请核对文件大小是否小于${checkValue}',
  },
  [CheckType.Version]: {
    ruleType: CheckType.Version,
    ruleLabel: '软件版本',
    checkValue: null,
    checkMethod: 'Equal',
    submitMessage: '软件版本号必须为${checkValue}',
    checkMessage: '请核对软件版本号是否为${checkValue}',
  },
  [CheckType.Unit]: {
    ruleType: CheckType.Unit,
    ruleLabel: '系统单位',
    checkValue: null,
    checkMethod: 'Equal',
    submitMessage: '模型的系统尺寸单位必须为${checkValue}',
    checkMessage: '请核对模型的系统尺寸单位是否为${checkValue}',
  },
  [CheckType.UVSet]: {
    ruleType: CheckType.UVSet,
    ruleLabel: 'UV套数',
    checkValue: null,
    checkMethod: 'Equal',
    submitMessage: '需提交${checkValue}套UV',
    checkMessage: '有${checkValue}套UV',
  },
  [CheckType.TexDependency]: {
    ruleType: CheckType.TexDependency,
    ruleLabel: '贴图依赖',
    checkValue: true,
    checkMethod: 'Equal',
    submitMessage: '模型中使用到的贴图必须全部提交',
    checkMessage: 'MAX模型中使用到的贴图未被提交，请核对提交的文件是否齐全',
  },
  [CheckType.Resolution]: {
    ruleType: CheckType.Resolution,
    ruleLabel: '分辨率',
    checkValue: {
      x: null,
      y: null,
    },
    checkMethod: 'Equal',
    submitMessage: '提交文件的分辨率为${checkValue}',
    checkMessage: '请核对文件的分辨率是否为${checkValue}',
  },
  [CheckType.Channel]: {
    ruleType: CheckType.Channel,
    ruleLabel: '颜色通道',
    checkValue: null,
    checkMethod: 'Equal',
    submitMessage: '图片的颜色通道为${checkValue}',
    checkMessage: '请核对图片的颜色通道是否为${checkValue}',
  },
  [GroupRulesEnum.FaceCount]: {
    ruleType: GroupRulesEnum.FaceCount,
    ruleLabel: '多边形面数',
    checkValue: null,
    checkMethod: 'Less',
    submitMessage: 'Group的多边形面数小于${checkValue}',
    checkMessage: '请核对Group的多边形面数是否小于${checkValue}',
  },
  [GroupRulesEnum.TriCount]: {
    ruleType: GroupRulesEnum.TriCount,
    ruleLabel: '三角面数',
    checkValue: null,
    checkMethod: 'Less',
    submitMessage: 'Group的三角面数小于${checkValue}',
    checkMessage: '请核对Group的三角面数是否小于${checkValue}',
  },
  [GroupRulesEnum.Normalized]: {
    ruleType: GroupRulesEnum.Normalized,
    ruleLabel: '重置变换',
    checkValue: true,
    checkMethod: 'Equal',
    submitMessage: '模型的中心点在bondingbox中',
    checkMessage: '请核对模型的中心点是否在bondingbox中',
  },
  [GroupRulesEnum.Center]: {
    ruleType: GroupRulesEnum.Center,
    ruleLabel: '重置轴心',
    checkValue: true,
    checkMethod: 'Equal',
    submitMessage: '模型已重置轴心',
    checkMessage: '请核对模型是否重置轴心',
  },
  [GroupRulesEnum.MeshName]: {
    ruleType: GroupRulesEnum.MeshName,
    ruleLabel: 'Mesh名称',
    checkValue: null,
    checkMethod: 'Reg',
    submitMessage: 'Mesh命名必须符合${checkValue}规范',
    checkMessage: 'Mesh命名不符合${checkValue}规范',
  },
  [GroupRulesEnum.MeshCount]: {
    ruleType: GroupRulesEnum.MeshCount,
    ruleLabel: 'Mesh数量',
    checkValue: null,
    checkMethod: 'Less',
    submitMessage: 'Mesh数量为${checkValue}',
    checkMessage: 'Mesh数量为${checkValue}',
  },
};

export const GroupTemplate: CheckItem = {
  itemId: '',
  name: '',
  type: CheckType.GroupCheck,
  rules: [],
  missing: undefined,
  fileName: '',
  fileName_desc: '',
  submitDir: '',
};

export const MaterialTemplate: CheckItem = {
  itemId: '',
  name: '',
  type: CheckType.MaterialCheck,
  rules: [],
  missing: undefined,
  fileName: '',
  fileName_desc: '',
  submitDir: '',
};

export const FileTemplate: CheckItem = {
  itemId: '',
  name: '',
  rules: [],
  type: '',
  missing: undefined,
  fileName: '',
  fileName_desc: '',
  submitDir: '',
};

export const ShowFileInfo = [
  CheckType.FileType,
  CheckType.FileSize,
  GroupRulesEnum.MeshCount,
  GroupRulesEnum.Normalized,
  GroupRulesEnum.FaceCount,
  GroupRulesEnum.TriCount,
  CheckType.Unit,
  CheckType.Channel,
  CheckType.Resolution,
  CheckType.Version,
];

export const getFileTypeCheckRulesMap = (format) => {
  const normal = [CheckType.FileName, CheckType.FileType, CheckType.IsRequired, CheckType.FileSize];
  switch (format) {
    case 'mov':
    case 'mp4':
    case 'avi':
      return [
        ...normal,
        CheckType.FrameRate,
        CheckType.BitRate,
        CheckType.Resolution,
        CheckType.ColorSpace,
        CheckType.TotalFrames,
      ];
    case 'max':
    case 'ma':
    case 'mb':
    case 'fbx':
      return [
        ...normal,
        CheckType.Version,
        CheckType.Unit,
        CheckType.UVSet,
        CheckType.TexDependency,
        CheckType.GroupCheck,
        CheckType.FrameRate,
        CheckType.MaterialCheck,
        CheckType.HasAnimation,
        CheckType.HasBinding,
        CheckType.HasSkeleton,
        CheckType.TotalFrames,
      ];
    case 'ztl':
      return [...normal];
    case 'tga':
    case 'jpg':
    case 'png':
    case 'jpeg':
    case 'gif':
    case 'psd':
    case 'psb':
      return [...normal, CheckType.Resolution, CheckType.Channel];
    case 'arp':
    case 'rs':
    case 'json':
    case 'yaotai':
    case 'spp':
      return [...normal];
    default:
      return normal;
  }
};
